import React from 'react';

export default function Mex() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_5958)'
      />
      <path
        d='M9.63636 25L6 22.5172V11.2207L15.8182 19.6621L26 11.3448V22.5172L22.2424 25V18.4207L15.8182 23.6345L9.63636 18.4207V25Z'
        fill='url(#paint1_linear_5201_5958)'
      />
      <path
        d='M9.0303 11.3448V7.62069L15.8182 13.331L23.0909 7.62069V11.3448L15.8182 17.4276L9.0303 11.3448Z'
        fill='url(#paint2_linear_5201_5958)'
      />
      <path
        d='M15.8182 11.2207L10.8485 7H21.1515L15.8182 11.2207Z'
        fill='url(#paint3_linear_5201_5958)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5958'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#4B77E4' />
          <stop offset='1' stop-color='#0C44D0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_5958'
          x1='5.84547'
          y1='3.30159'
          x2='18.3608'
          y2='23.6842'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5201_5958'
          x1='5.84547'
          y1='3.30159'
          x2='18.3608'
          y2='23.6842'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_5201_5958'
          x1='5.84547'
          y1='3.30159'
          x2='18.3608'
          y2='23.6842'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
